// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportFormatDetails.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');

  var trackable = require('share/tracking/Izenda.Trackable');
  var UIConstants = require('logic/data/Izenda.UIConstants');
  var setValue = require('share/utils/Izenda.setValue');
  var constants = require('logic/data/Izenda.ReportDesignerFormatsConstants');
  var { uniqueId, lowerCase } = require('lodash/fp');

  function ReportFormatDetails(data) {
    var props = {
      type: 'text',
      label: 'Text',
      id: uniqueId('formatDetails_'),
      positionX: 0,
      positionY: 0,
      width: 1,
      height: 1,
      /* itemProps*/
      name: '',
      sortName: function() {
        return lowerCase(this.name);
      },
      value: '',
      format: null,
      font: {
        family: UIConstants.fontFamily.proxima,
        size: UIConstants.defaultFontSize,
        bold: false,
        italic: false,
        underline: false,
        color: UIConstants.textColor,
        backgroundColor: UIConstants.textBackgrounColor
      },
      alignment: null,
      color: UIConstants.borderColor,
      imageUrl: '',
      imageDimensions:{
        imageWidth: 1,
        imageHeight: 1,
        isConstrainProportions:true
      },
      dashStyle: UIConstants.defaultDashStyles,
      thickness: UIConstants.borderWidth,
      isSelected: false,
      minHeight: constants.DEFAULT_ITEM_MIN_HEIGHT
    };

    m.extendObservable(trackable(this), props);

    data && this.populateData(data);

    this.resetDirty();
  }

  /**
   * Populate data for this report format details.
   * @param {object} data
   */
  ReportFormatDetails.prototype.populateData = m.action(function(data) {
    data = data || {};

    this.type = data.type;
    this.label = data.label;
    this.positionX = data.positionX;
    this.positionY = data.positionY;
    this.width = data.width;
    this.height = data.height;
    /* itemProps*/
    this.name = data.name;
    this.value = data.value;
    this.format = data.format;
    this.font = data.font || {
      family: UIConstants.fontFamily.proxima,
      size: UIConstants.defaultFontSize,
      bold: false,
      italic: false,
      underline: false,
      color: UIConstants.textColor,
      backgroundColor: UIConstants.textBackgrounColor
    };
    this.alignment = data.alignment;
    this.color = data.color || UIConstants.borderColor;
    this.imageUrl = data.imageUrl;
    this.dashStyle = data.dashStyle || UIConstants.defaultDashStyles;
    this.thickness = data.thickness || UIConstants.borderWidth;
    this.minHeight = data.minHeight;
    this.imageDimensions = data.imageDimensions || {
      imageWidth: 1,
      imageHeight: 1,
      isConstrainProportions:true
    };
  });

  /**
   * Set position this report format details.
   * @param {object} position
   */
  ReportFormatDetails.prototype.setPosition = m.action(function(position) {
    this.positionX = position.positionX;
    this.positionY = position.positionY;
    this.width = position.width;
    this.height = position.height;
    this.markDirty();
  });

  /**
   * Get value by key
   * @param  {string} key
   */
  ReportFormatDetails.prototype.getValueByKey = function(key) {
    return this[key];
  };

  /**
   * Set format items details
   * @param {object} data
   */
  ReportFormatDetails.prototype.setItemsDetails = m.action(function(data) {
    var font = this.font;
    var imageDimensions=this.imageDimensions;

    data = data || {};
    var dimensions=data.imageDimensions || imageDimensions;
   
    data.name && setValue(this, 'name', data.name);
    data.value && setValue(this, 'value', data.value);
    data.imageUrl && setValue(this, 'imageUrl', data.imageUrl);
    setValue(this, 'format', data.format);
    setValue(this, 'alignment', data.alignment);
    setValue(this, 'color', data.color);
    setValue(this, 'dashStyle', data.dashStyle);
    setValue(this, 'thickness', data.thickness);
    setValue(font, 'family', data.family);
    setValue(font, 'size', data.size);
    setValue(font, 'bold', data.bold);
    setValue(font, 'italic', data.italic);
    setValue(font, 'underline', data.underline);
    setValue(font, 'color', data.textColor);
    setValue(font, 'backgroundColor', data.textBackgrounColor);
    setValue(this, 'width', data.width);
    setValue(this, 'height', data.height);
    setValue(imageDimensions, 'imageWidth', dimensions.imageWidth);
    setValue(imageDimensions, 'imageHeight', dimensions.imageHeight);
    setValue(imageDimensions, 'isConstrainProportions', dimensions.isConstrainProportions);
    this.markDirty();
  });

  /**
   * Set format items value
   * @param {string} key
   * @param {string} key
   */
  ReportFormatDetails.prototype.updateValueByKey = function(key, value) {
    this[key] = value;
    this.markDirty();
  };

  module.exports = ReportFormatDetails;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ReportFormatDetails.js